var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CChartBar',{attrs:{"datasets":_vm.computedDatasets,"options":_vm.computedOptions,"labels":_vm.labels}})}
var staticRenderFns = []

export { render, staticRenderFns }